<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { computed } from 'vue'
  import { cn } from '@/lib/utils'
  import { useTranslation } from '@/composables/useTranslation'

  const props = defineProps<{
    percentage: number
    class?: HTMLAttributes['class']
  }>()

  const { t } = useTranslation({
    en: {
      matchScore: 'Match score'
    },
    de: {
      matchScore: 'Übereinstimmungsgrad'
    }
  })

  const colorClasses = computed(() => {
    if (props.percentage >= 80) {
      // High confidence
      return 'bg-green-50 text-green-700 border-green-200'
    } else if (props.percentage >= 50) {
      // Medium confidence
      return 'bg-amber-50 text-amber-700 border-amber-200'
    } else {
      // Low confidence
      return 'bg-red-50 text-red-700 border-red-200'
    }
  })
</script>

<template>
  <div
    :class="
      cn(
        'inline-flex items-center rounded-lg border px-2.5 py-1 text-sm font-medium',
        colorClasses,
        props.class
      )
    "
  >
    {{ t('matchScore') }}: {{ percentage }}%
  </div>
</template>
